var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-4"
  }, [_c('HeaderDetailItemSR', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "optionsTaskType": _vm.optionsTaskType,
      "optionsDepartment": _vm.optionsDepartment,
      "optionsCategory": _vm.optionsCategory,
      "optionsClassification": _vm.optionsClassification,
      "optionsCause": _vm.optionsCause,
      "optionsKindTask": _vm.optionsKindTask,
      "editable": false
    }
  }), _c('b-row', [_c('b-col', {
    staticClass: "mt-4 mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('CustomNav', {
    attrs: {
      "items": _vm.tabs
    },
    on: {
      "item-click": function itemClick(val) {
        return _vm.activeTab = val;
      }
    }
  })], 1), _vm.activeTab == 1 && !_vm.readonly ? _c('b-col', {
    staticClass: "d-flex justify-content-end",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.showSidebar = true;
      }
    }
  }, [_vm._v("Add Progress Activity")])], 1) : _vm._e(), _c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "md": "12"
    }
  }, [_vm.activeTab == 1 ? [_c('ListDailyProgress', {
    attrs: {
      "data": _vm.listActivity
    }
  })] : _vm._e(), _vm.activeTab == 2 ? [_c('ListInternalManPower', {
    attrs: {
      "data": _vm.selectedItem.internal_manpower
    }
  })] : _vm._e(), _vm.activeTab == 3 ? [_c('ListSubContractor', {
    attrs: {
      "data": _vm.selectedItem.subcons
    }
  })] : _vm._e()], 2)], 1), _c('b-sidebar', {
    attrs: {
      "right": "",
      "width": "50%",
      "title": "Add Progress Item Repair",
      "shadow": "",
      "bg-variant": "white"
    },
    on: {
      "hidden": _vm.onHide
    },
    model: {
      value: _vm.showSidebar,
      callback: function callback($$v) {
        _vm.showSidebar = $$v;
      },
      expression: "showSidebar"
    }
  }, [_c('form', {
    staticClass: "p-3",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSaveBulk.apply(null, arguments);
      }
    }
  }, [_vm._l(_vm.formActivity, function (form, index) {
    return _c('div', {
      key: index,
      staticClass: "card-sr-information-form p-3 border mb-3"
    }, [_c('b-row', [_c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "12"
      }
    }, [_c('label', {
      attrs: {
        "for": "activity"
      }
    }, [_vm._v("Activity "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('b-form-select', {
      attrs: {
        "required": "",
        "size": "sm",
        "options": _vm.optionsActivity
      },
      model: {
        value: form.activity_id,
        callback: function callback($$v) {
          _vm.$set(form, "activity_id", $$v);
        },
        expression: "form.activity_id"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "6"
      }
    }, [_c('label', {
      attrs: {
        "for": "activity"
      }
    }, [_vm._v("Start Activity "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('date-picker', {
      staticClass: "w-100",
      attrs: {
        "value-type": "YYYY-MM-DD HH:mm:ss",
        "type": "datetime",
        "placeholder": "Select date and time",
        "format": "DD-MM-YYYY HH:mm:ss"
      },
      model: {
        value: form.date_of_activity,
        callback: function callback($$v) {
          _vm.$set(form, "date_of_activity", $$v);
        },
        expression: "form.date_of_activity"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "6"
      }
    }, [_c('label', {
      attrs: {
        "for": "activity"
      }
    }, [_vm._v("End Activity "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('date-picker', {
      staticClass: "w-100",
      attrs: {
        "value-type": "YYYY-MM-DD HH:mm:ss",
        "type": "datetime",
        "placeholder": "Select date and time",
        "format": "DD-MM-YYYY HH:mm:ss",
        "disabled-date": function disabledDate(date) {
          return _vm.disableEndDate(date, form);
        },
        "disabled": !form.date_of_activity
      },
      model: {
        value: form.end_of_activity,
        callback: function callback($$v) {
          _vm.$set(form, "end_of_activity", $$v);
        },
        expression: "form.end_of_activity"
      }
    })], 1), _c('b-col', {
      attrs: {
        "md": "6"
      }
    }, [_c('label', {
      attrs: {
        "for": "activity"
      }
    }, [_vm._v("Activity Attachment")]), _c('InputFileMultiple', {
      attrs: {
        "files": form.filePreview
      },
      on: {
        "change-files": function changeFiles(val) {
          return _vm.handleInputFiles(val, form);
        }
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3 mt-2",
      attrs: {
        "md": "12"
      }
    }, [_c('b-row', {
      staticClass: "m-0"
    }, _vm._l(form.filePreview, function (url, idx) {
      return _c('b-col', {
        key: "".concat(index, "-").concat(idx),
        staticClass: "p-0 pr-2",
        attrs: {
          "lg": "3"
        }
      }, [_c('AttachmentSR', {
        attrs: {
          "modelId": form.id,
          "modelName": "sr_form_repair_activity",
          "file": url
        },
        on: {
          "delete": function _delete() {
            return _vm.handleDeleteFile(form, idx);
          }
        }
      })], 1);
    }), 1)], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "12"
      }
    }, [_c('label', {
      attrs: {
        "for": "activity"
      }
    }, [_vm._v("Remarks")]), _c('b-form-textarea', {
      staticClass: "bg-white",
      model: {
        value: form.notes,
        callback: function callback($$v) {
          _vm.$set(form, "notes", $$v);
        },
        expression: "form.notes"
      }
    })], 1)], 1)], 1);
  }), _c('div', {
    staticClass: "mt-3 d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.showSidebar = false;
      }
    }
  }, [_vm._v("Cancel & Close")]), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.addForm
    }
  }, [_vm._v("Add Form")]), !_vm.loading ? _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Save & Close")]) : _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)], 1)], 2)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }